import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useMouse } from "@vueuse/core";
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

interface Props {
    images?: Array<string>;
    sitename: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    images: { type: Array, required: false },
    sitename: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const mycarousel = ref();
const showRightArrow = ref(false);
const showLeftArrow = ref(false);

const { x, y } = useMouse();



const __returned__ = { mycarousel, showRightArrow, showLeftArrow, x, y, Carousel, Slide }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})